(function () {
  // Locate the product's Globo app WITHOUT relying on the per-product
  // option-set-id metafield as the sole anchor: that metafield
  // (custom.gpo_option_set_id) drifts out of sync whenever Globo regenerates
  // option-set ids, and when it mismatches the rendered app the guard used to
  // silently no-op -> the button stayed UNGATED -> a frame could be customized
  // and carted with no Size (critical fulfillment bug).
  //
  // Resolution is STRICTLY scoped to the button's own product section. We must
  // never bind to a `.gpo-app` from elsewhere in the document (related-products
  // / recently-viewed / quick-view carousels each render their own app): the
  // metafield id is stale and frequently belongs to a DIFFERENT product, so a
  // document-wide lookup on that id could bind the guard to the wrong product's
  // options and fail open. If we can't find the product section, we return null
  // (button stays normal) rather than risk binding to a foreign app.
  function findGpoApp(customizeBtn) {
    const section =
      customizeBtn.closest('[data-section-type="product-page"]') ||
      document.querySelector('[data-section-type="product-page"]');
    if (!section) return null;

    const wanted = (customizeBtn.getAttribute('data-gpo-option-set-id') || '').trim();
    if (wanted) {
      const byId = section.querySelector(`.gpo-app[data-option-set-id="${wanted}"]`);
      if (byId) return byId;
    }
    return section.querySelector('.gpo-app');
  }

  function initForButton(customizeBtn) {
    // Find the GPO app for this product/page (proximity-based, id-tolerant).
    const gpoApp = findGpoApp(customizeBtn);
    if (!gpoApp) return false;

    // prevent double init
    if (customizeBtn.dataset.gpoGuardInit === '1') return true;
    customizeBtn.dataset.gpoGuardInit = '1';

    // message element (placed after button, no layout changes)
    let msg = customizeBtn.parentElement.querySelector('.cus-required-msg');
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'cus-required-msg';
      msg.innerText = 'Please first select the required variant options above';
      customizeBtn.insertAdjacentElement('afterend', msg);
    }

    // An option element is "hidden" when it (or an ancestor up to the app) is
    // collapsed/display:none. We never gate on a field the buyer can't see —
    // that's exactly the "permanently locked" trap we're avoiding.
    function isActive(el) {
      let node = el;
      while (node && node !== gpoApp) {
        if (node.classList && (node.classList.contains('hidden') || node.classList.contains('gpo-hidden'))) return false;
        if (node.style && node.style.display === 'none') return false;
        node = node.parentElement;
      }
      return true;
    }

    // An option counts as "selected" when its live control holds a real value.
    // Handles all three ways Globo renders an option:
    //   - radio/checkbox group -> at least one checked
    //   - <select>             -> non-empty value (the "-- Please select --"
    //                             placeholder serializes as "", so an untouched
    //                             must-choose field stays unselected on purpose)
    //   - text / textarea      -> non-empty value
    function elementSelected(el) {
      const controls = Array.prototype.slice.call(
        el.querySelectorAll('input[name], select[name], textarea[name]')
      );
      if (!controls.length) return true; // nothing to choose -> not blocking

      const radios = controls.filter(function (c) {
        return c.type === 'radio' || c.type === 'checkbox';
      });
      if (radios.length) {
        return radios.some(function (c) { return c.checked; });
      }

      const select = controls.filter(function (c) {
        return c.tagName === 'SELECT';
      })[0];
      if (select) {
        return !!(select.value && String(select.value).trim());
      }

      return controls.some(function (c) {
        return !!(c.value && String(c.value).trim());
      });
    }

    // Required options are derived from Globo itself: each option is a
    // `.gpo-element`, and Globo marks the required ones with a `.gpo-label.required`
    // label. This means the gate auto-adapts to whatever the merchant marks
    // required in the Globo dashboard (the "Your Fit" fields) — no per-product
    // metafield to maintain. Re-scanned on every validate so late/conditional
    // renders are picked up.
    function requiredElements() {
      return Array.prototype.slice
        .call(gpoApp.querySelectorAll('.gpo-element'))
        .filter(function (el) { return el.querySelector('.gpo-label.required'); })
        .filter(isActive);
    }

    function validate() {
      // [].every(...) === true -> if Globo marks nothing required, fail open.
      const isValid = requiredElements().every(elementSelected);

      // Gate the redirect without changing layout.
      customizeBtn.style.pointerEvents = isValid ? 'auto' : 'none';
      customizeBtn.style.opacity = isValid ? '1' : '0.6';
      msg.style.display = isValid ? 'none' : 'block';
    }

    validate();
    gpoApp.addEventListener('change', validate);

    const innerObserver = new MutationObserver(validate);
    innerObserver.observe(gpoApp, { childList: true, subtree: true });

    return true;
  }

  function initAll() {
    document
      .querySelectorAll('sa-customize-frame-button.m-product-customize-frame')
      .forEach(initForButton);
  }

  // initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // in case GPO loads late
  const observer = new MutationObserver(() => initAll());
  observer.observe(document.body, { childList: true, subtree: true });
})();
